module.exports = __webpack_public_path__ + "static/img/jcyy-banner.ad87444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/chartTexeraJc/jcyy-banner.png
// module id = j/f5
// module chunks = 34